import _ from 'lodash'
import { ENTRIES_LOADED } from '../constants';

const initialState = {byContentfulId: {}, all:[]};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.performance) {
                const result = initialState;
                Object.keys(action.entries.performance).map(key => {
                    if (!action.entries.performance[key].endDate) {
                        action.entries.performance[key].endDate = action.entries.performance[key].startDate;
                    }
                    result.byContentfulId[key] = action.entries.performance[key];
                    result.all.push(action.entries.performance[key]);
                })
                return result
            }
            break;
    }
    return state;
}
